import { LOYALTY_LEAD_REGIONS } from 'loyalty/constants/loyaltyConfig'

function getIsLoyaltyLeadRegion(state: App.State): boolean {
  if (!state.geo.currentRegionCode) return false
  return LOYALTY_LEAD_REGIONS.some(region => region === state.geo.currentRegionCode)
}

export default getIsLoyaltyLeadRegion
